import React from 'react';
import UserInfo from '../LeadWebForm/userInfo';
import ModalForms from '../Shared/Modals';
import { Box, Button } from '@mui/material';
import { useRecoilValue, useRecoilState } from 'recoil';
import { userDetailAtom, userInfoFormEnableDisableAtom, userRawLeadFormDataAtom } from '../../Services/_states';
import { LeadFormActions } from '../../Services/_actions/index';
import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';

const EditSupplierModal = ({ props }) => {
    const { open, onClose, title = '' } = props;

    const userDetailByNumber = useRecoilValue(userDetailAtom);
    const [userRawLeadData, setUserRawLeadData] = useRecoilState(userRawLeadFormDataAtom);
    const [userInfoFormEnable, setUserInfoFormEnable] = useRecoilState(userInfoFormEnableDisableAtom);
    const leadFormActions = LeadFormActions();
    const { showSnackBar } = useSnackBar();

    const handleSave = async () => {
        const data = {
            company_id: userDetailByNumber?.company_id,
            data: userRawLeadData?.data,
            form_id: userDetailByNumber?.form_id,
            phone_number: userDetailByNumber?.phone_number,
        };

        try {
            let res;
            res = await leadFormActions.updateUserDetail(data);
            if (res?.status === 200) {
                showSnackBar('Information updated successfully', 'success');
                setUserInfoFormEnable(true);
                onClose(null, 'success');
            } else if (res?.data?.data?.general_error) {
                showSnackBar(res.data.data.general_error, 'error');
            } else {
                showSnackBar('Information not updated successfully', 'error');
            }
        }
        catch (error) {
            showSnackBar('Something went wrong', 'error');
        }
    };

    return (
        <ModalForms
            show={open}
            handleClose={() => onClose(null, 'cancel')}
            modalHeader="Update Supplier"
            modalBody={<UserInfo />}
            modalId={title}
            size="md"
            modalFooter={
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <Button variant="outlined" onClick={() => onClose(null, 'cancel')}>
                        Cancel
                    </Button>
                    <Button variant="contained" onClick={handleSave}>
                        Save
                    </Button>
                </Box>
            }
        />
    );
};

export default EditSupplierModal;
